/**
 * @file: useInviteLink.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useAppLoading } from '@euler/components/loading/Provider';
import { useServiceFactory } from '@euler/services/factory';
import { showAlert } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { useState } from 'react';

export const useInviteLink = () => {
  const [inviteLink, setInviteLink] = useState<string>();
  const { storeService } = useServiceFactory();
  const appLoading = useAppLoading();

  const prepareInviteLink = usePersistFn(async () => {
    if (inviteLink == null) {
      appLoading.show();
      try {
        const link = await storeService.getInviteLink();
        setInviteLink(link);
        return link;
      } catch (e) {
        void showAlert('获取分享信息失败', (e as Error).message);
      } finally {
        appLoading.hide();
      }
    }
    return inviteLink;
  });

  return {
    inviteLink,
    prepareInviteLink,
  };
};
